/* this file added by Bearer Web Developer  */
import React, { useContext } from 'react';
import styles from './dataTime.module.scss';
import { ReservedOrderInfoContext } from '../contexts/reservedOrderInfo';
import { useThemeMode } from '../../../../../../states/contexts/theme';

const DataTime: React.FC = () => {
    const reservedOrderDetails = useContext(ReservedOrderInfoContext);
    const reservation_expiry_time = reservedOrderDetails?.reservation_expiry_time;     
    const earliest_pickup_time = reservedOrderDetails?.earliest_pickup_time;     
    const is_time_sensitive_order = reservedOrderDetails?.is_time_sensitive_order;
    const earliest = earliest_pickup_time && is_time_sensitive_order;
    const miliseconds = Number(earliest ? earliest_pickup_time : reservation_expiry_time);
    const date = new Date(miliseconds).toLocaleDateString();
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const text = earliest ? 'Pick up by' : 'Expiry time';
    return (
        <div className={styles.expire_time} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h4>{text}{':'} <span>{date}</span></h4>
        </div>
    )
}

export default DataTime;